import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Main from '../../layouts/Main';
import Container from '../../components/Container';
import {
  Hero,
  FeaturedServices,
  LatestNews,
  LatestEvents,
  Subscription,
  TrainingCourses,
  MunicipalMap,
  FollowTheMoney,
  Contact,
} from './components';
import GovernorElectionCharts from '../Data/components/GovernorElectionCharts';
import BallotQuestionCharts from '../Data/components/BallotQuestionCharts';


const Home1 = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Main>
       {/* <Box margin="20px 0 0 5px" display="flex" justifyContent="center" alignItems="center">
        <Alert severity="warning" sx={{ width: '95%' }}>
          Due to the nature of work being conducted by DCAMM on the 4th floor of One Ashburton Place,
          all OCPF staff are working remotely. It is expected that the work will last until approximately February 6, 2026. 
          During this time, OCPF staff can be contacted by email (ocpf@mass.gov) and telephone (617-979-8300), or click <Link href="/About/ContactUs">here</Link> for the Staff Directory.
        </Alert>
      </Box> */}
       
      {/*Search*/}
      <Hero />
      {/*Services*/}
      <Container>
        <FeaturedServices />
      </Container>

      {/* featured election Charts     */}
      
       <Box> 
        <Container>
          <Box marginBottom={4}>
                  <Typography
                    variant="h4"
                    align={'center'}
                    gutterBottom
                    fontWeight={550}
                  >
                    Featured Election
                  </Typography>
                </Box>
          <BallotQuestionCharts />
        </Container>
      </Box>
     
      {/*Data search*/}
        <Container>
          <FollowTheMoney></FollowTheMoney>
        </Container>
     
      {/*News*/}
      <Box
        position={'relative'}
        sx={{
          backgroundColor: theme.palette.alternate.main,
        }}
      > 
        <Box>
            <Box>
              <Typography
                variant="h4"
                align={'center'}
                data-aos={'fade-up'}
                gutterBottom
                fontWeight={700}
                paddingTop={4}
              >
                News & Events
              </Typography>
            </Box>
            <Container>
              <Grid container spacing={isMd ? 4 : 0}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <LatestNews />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <LatestEvents />
              </Grid>
            </Grid>
            </Container>
        </Box>
        <Box
          component={'svg'}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1920 100.1"
          sx={{
            width: '100%',
            marginBottom: theme.spacing(-1),
          }}
        >
          <path
            fill={theme.palette.background.paper}
            d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
          ></path>
        </Box>
      </Box>
      <Box>
        <Container>
          <MunicipalMap />
        </Container>
      </Box>
      <Box
       sx={{
        backgroundColor: theme.palette.alternate.main,
      }}  
      >
        <Container>
          <TrainingCourses />
        </Container>
      </Box>
       {/*Subscription*/}
      <Box
        sx={{
          background: 'transparent',
          backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 40%, ${theme.palette.primary.main} 0%)`,
        }}
      >
        <Container>
          <Subscription />
        </Container>
      </Box>
      <Box
      sx={{
        backgroundColor: theme.palette.alternate.main,
      }}
      >
        <Container>
          <Contact />
        </Container>
      </Box>
    </Main>
  );
};

export default Home1;
